import { IoCloseOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router";
import { usePreviousPagePath } from "../../hook/usePreviousPagePath";
import useDeviceType from "../../hook/useDeviceType";

const CloseComponent = ({ delay, setProps }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const previousPage = usePreviousPagePath();

  const deviceType = useDeviceType();

  const pathArray = location.pathname.split("/");

  const profileIndex = pathArray.indexOf("profile");

  return (
    <IoCloseOutline
      className="cursor-pointer"
      onClick={() => {
        localStorage.clear();
        if (
          deviceType === "Mobile" &&
          !location.pathname.includes("/profile")
        ) {
          navigate("../../");
          return;
        } else {
          navigate(pathArray.slice(0, profileIndex).join("/"));
        }
      }}
    />
  );
};

export default CloseComponent;
